import React from "react";
import remove_icon from "../../assets/images/icon-remove.svg";
import Select from "react-select";
import useAuth from "../../hooks/useAuth";

export const SearchRelease: React.FC<any> = (props) => {
  const {
    client = [],
    label = [],
    type = [],
    clientList = [],
    labelList = [],
    typeList = [],
    handleClient,
    handleLabel,
    handleType,
  } = props.data;

  const { user } = useAuth() as any;

  return (
    <div className="search-component">
      <div className="container uk-container-large">
        {/* <div className="label title-label fw-bold mb-4">
          Which releases are you looking for?
        </div> */}
        <div className="search-content row d-flex flex-row position-relative">
          <div className="col-md-6 search-item-title release title-label fw-bold">Catalog</div>
          {/* <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Name</div>
              <div className="count-found">found {clientList.length}</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  clientList?.map((item: any) => ({
                      value: item.id,
                      label: item.title
                  }))
                }
                onChange={(item: any) =>
                  {
                    if((user?.profile?.client_id===null&&+item.value===2)||(user?.profile?.client_id==+item.value)){
                    // if(+item.value===2){
                      // handleClient(+item.value)
                    }else{
                      alert("Please contact Cugate Ltd. for access permissions.");
                    }
                  }
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {client?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"client_" + item}
                  // onClick={() => handleClient(item)}
                >
                  <div className="me-2 title">{clientList.filter((c: any)=>c.id===item).length?clientList.filter((c: any)=>c.id===item)[0].title:''}</div>
                  {/* <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  />
                </div>
              ))}
            </div>
          </div> */}
          <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Label</div>
              <div className="count-found">found {labelList.length}</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  labelList.filter((l: any) => l.key != null)?.map((a: any) => ({
                    value: a.key,
                    label: a.title
                  }))
                }
                onChange={(item: any) =>
                  handleLabel(item.value)
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {label?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"label_" + item}
                  onClick={() => handleLabel(item)}
                >
                  <div className="me-2 title">{labelList.filter((c: any) => c.key === item).length ? labelList.filter((c: any) => c.key === item)[0].title : ''}</div>
                  <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Type</div>
              <div className="count-found">found {typeList.length}</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  typeList?.map((a: any) => ({
                    value: a.id,
                    label: a.title
                  }))
                }
                onChange={(item: any) =>
                  handleType(+item.value)
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {type?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"type_" + item}
                  onClick={() => handleType(item)}
                >
                  <div className="me-2 title">{typeList.filter((c: any) => c.id === item).length ? typeList.filter((c: any) => c.id === item)[0].title : ''}</div>
                  <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchRelease;
